import Vue from 'vue'
import mixpanel from 'mixpanel-browser'

export default ({ app }, inject) => {
  mixpanel.init(app?.$config?.mixpanelToken, {
    api_host: app?.$config?.mixpanelApiHost,
    autocapture: false,
    track_pageview: true,
    persistence: "cookie",
    cookie_domain: app?.$config?.tokenCookieDomain,
    cross_subdomain_cookie: true,
    record_sessions_percent: 100,
    record_heatmap_data: true,
    record_mask_text_selector: "",
    record_block_selector: "",
  })

  mixpanel.register({
    platform: 'nuxt-web',
    app_version: process.env.appVersion || 'unknown'
  })

  const $mixpanel = {
    getInstance() {
      return mixpanel;
    },

    track(event, properties = {}) {
      mixpanel.track(event, {
        ...properties,
        platform: 'nuxt-web'
      })
    },

    identify(user) {
      if (!user || !user.userId) return

      const anonymousId = mixpanel.get_distinct_id()

      if (anonymousId !== user.userId) {
        mixpanel.alias(user.userId, anonymousId)
      }

      mixpanel.identify(user.userId)

      mixpanel.people.set({
        $anon_id: anonymousId,
        $name: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.email,
        $first_name: user.firstName,
        $last_name: user.lastName,
        $email: user.email,
        ...user.traits
      })
    },

    startSession(userId) {
      const sessionId = Date.now().toString()
      localStorage.setItem('mp_session_id', sessionId)

      this.track('Session Started', {
        session_id: sessionId,
        distinct_id: userId || mixpanel.get_distinct_id()
      })
    },

    endSession(userId) {
      const sessionId = localStorage.getItem('mp_session_id')

      if (sessionId) {
        this.track('Session Ended', {
          session_id: sessionId,
          distinct_id: userId || mixpanel.get_distinct_id()
        })
        localStorage.removeItem('mp_session_id')
      }
    },

    reset() {
      mixpanel.reset()
    }
  }

  Vue.prototype.$mixpanel = $mixpanel
  inject('mixpanel', $mixpanel)

  $mixpanel.startSession()

  app.router.afterEach((to) => {
    Vue.nextTick(() => {
      $mixpanel.track('Page View', {
        page: to.fullPath,
        title: document.title
      })
    })
  })

  if (process.client) {
    window.addEventListener('beforeunload', () => {
      $mixpanel.endSession()
    })
  }
}
